<div calss="menu">
    @for (subMenuItem of menuItems['menuItems']; track subMenuItem; let i = $index) {
      <mat-list-item 
        class="sub-menu" 
        button="true" 
        lines="none" 
        (click)="navigateTo(subMenuItem['link'], menuItems, subMenuItem, subMenuItem['queryParams'])">

        <div 
        class="sub-list-items"
        [ngClass]="{'active': subMenuItem['active']}" >
          @if (subMenuItem.customIcon != null && subMenuItem.customIcon) {
            <mat-icon slot="start">
              <img 
                class="huge-icon" 
                slot="start" 
                [src]="subMenuItem['active'] && subMenuItem.activeIcon ? subMenuItem.activeIcon : subMenuItem.subIcon"/>
            </mat-icon>
          } 
          @if (subMenuItem.customIcon == null || !subMenuItem.customIcon) {
            <mat-icon slot="start">{{ subMenuItem.icon }}</mat-icon>
          }
          <mat-label [ngClass]="{'active': subMenuItem['active']}">
            {{ subMenuItem['title'] }}
          </mat-label>
        </div>
      </mat-list-item>
    }
  </div> 